// Carousel configuration
const FLICKITY_CONFIG = {
  prevNextButtons: false,
  pageDots: true,
  wrapAround: true,
  draggable: true,
  autoPlay: 4000,
  cellAlign: 'center',
  contain: true,
  setGallerySize: true,
  adaptiveHeight: false,
  percentPosition: true,
  watchCSS: false
};

// Function to initialize or reinitialize carousel
const initCarousel = () => {
  const carousel = document.querySelector('.cart-reinsurance__carousel');
  if (!carousel) return;
  try {
    const FlktyInstance = Flickity.data(carousel);
    if (FlktyInstance) {
      FlktyInstance.destroy();
    }
    new Flickity(carousel, FLICKITY_CONFIG);
  } catch (error) {
    console.error('Error when initializing carousel:', error);
  }
};

// Event listener for drawer opening
document.addEventListener('DrawerOpen', e => {
  if (e.detail.drawer === "site-cart-sidebar") {
    initCarousel();
  }
});

// Event listener for cart update
document.addEventListener('cart:refreshed', initCarousel);